export const API_GET_EXTERNAL_SERVICES_STATUS = "API_GET_EXTERNAL_SERVICES_STATUS";
export const API_GET_EXTERNAL_SERVICES_STATUS_SUCCESS = "API_GET_EXTERNAL_SERVICES_STATUS_SUCCESS";
export const API_GET_EXTERNAL_SERVICES_STATUS_FAIL = "API_GET_EXTERNAL_SERVICES_STATUS_FAIL";
export const API_POST_EXTERNAL_SERVICES_STATUS = "API_POST_EXTERNAL_SERVICES_STATUS";
export const API_POST_EXTERNAL_SERVICES_STATUS_SUCCESS = "API_POST_EXTERNAL_SERVICES_STATUS_SUCCESS";
export const API_POST_EXTERNAL_SERVICES_STATUS_FAIL = "API_POST_EXTERNAL_SERVICES_STATUS_FAIL";
